import { prestigeClient } from "..";
import { QueryBuilder } from "../../../lib/directus-sdk/query-builder";

export const prestigeTierBuilder = new QueryBuilder("prestige_tier")
  .select([
    "name",
    { badge_image: ["id", "title"] },
    {
      translations: {
        fields: ["title"],
      },
    },
  ])
  .where({
    name: { _eq: "Silver" },
  });

export const prestigeTierClient = prestigeClient
  .query(prestigeTierBuilder)
  .key("prestige_tier");



// WEBPACK FOOTER //
// ./src/app/common/directus/prestige/prestige_tier.js